exports.initTealium = () => {
  if (!document) return;

  // Work out what environment we are running in (client-side)
  const tealiumEnv = (() => {
    switch (document.location.host.split(".")[1]) {
      case undefined: // Localhost
      case "dev":
      case "uat":
      case "pre":
        return "dev";
      default:
        return "prod";
    }
  })();

  let a = `//tags.tiqcdn.com/utag/${process.env.GATSBY_TEALIUM_TAG_ID}/${tealiumEnv}/utag.js`,
    b = document,
    c = "script",
    d = b.createElement(c);
  d.src = a;
  d.type = "text/java" + c;
  d.async = true;
  a = b.getElementsByTagName(c)[0];
  a.parentNode.insertBefore(d, a);
};

exports.updateTealiumPage = location => {
  if (typeof window.utag !== "undefined") {
    window.utag.view({ page_name: location.pathname });

    //LinkedIn Event
    window.utag.view({
      tealium_event: "linkedin_event",
    });

    //Bing Event
    window.uetq = window.uetq || [];
    window.uetq.push({
      ec: window.location.href,
      ea: "Pageview",
      el: window.location.href,
    });
  }
};
